/**
 * @file Re-exports the Amplify authenticator context component.
 */
import AuthenticatorContext from "./AuthenticatorContext";

export default AuthenticatorContext;
